import { Avatar, Button, Grid, Typography } from "@material-ui/core";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getMyIdeaList,
  getMyReserveIdeaList,
  resetMyIdeasList,
} from "screens/Ideation/actions";
import useStyles from "screens/Ideation/style";
import { useInjectReducer } from "utilize/injectReducer";
import { useInjectSaga } from "utilize/injectSaga";
// import saga from "../saga";
// import reducer from "../reducer";

import { useState } from "react";

import Path from "assets/image/ideation/_Compound_Path_.svg";
import lampChargeRed2 from "assets/image/ideation/lamp_charge_red_2.svg";
import myIdeasVector from "assets/image/ramadan.png";
import noteRedWhite from "assets/image/ideation/note_red_white.svg";

import { Helmet } from "react-helmet";

import InfiniteScrollMyIdea from "screens/Ideation/components/InfiniteScrollMyIdea";
import Apis from "constants/Api";
import AddActivityModalVerses from "./AddActivityModal";

export default function VersesAct() {
  // useInjectReducer({ key: "ideation", reducer });
  // useInjectSaga({ key: "ideation", saga });
  const classes = useStyles();
  const [tab, setTab] = useState(1);
  const [showAddActivityModal, setShowAddActivityModal] = useState(false);
  const userName = useSelector((state) => state?.main?.currentUser?.name);
  const user = useSelector((state) => state?.main?.currentUser);
  const roles = useSelector((state) => state?.main?.currentUser?.roles);
  const userPhoto = useSelector((state) => state?.main?.currentUser?.photo);
  const rolesName = roles?.map((item) => item?.role + " " + item?.unit);
  // const dispatch = useDispatch();
// console.log(user);
  const [filterIdea, setFilterIdea] = useState("all");

  // useEffect(() => {
  //   dispatch(getMyIdeaList(filterIdea));
  // }, [filterIdea]);
  // useEffect(() => {
  //   dispatch(getMyReserveIdeaList());
  // }, []);

  // const handleIdeaFilters = (filter) => {
  //   dispatch(resetMyIdeasList());
  //   setFilterIdea(filter);
  // };
  const handleActiveTab = (id) => {
    setTab(id);
  };

  return (
    <>
      <Helmet>
        <title>{`عقیق : کنش های من  `}</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Grid container justify="center" style={{ backgroundColor: "#fff" }}>
        <Grid container direction="column" className={classes.root}>
          <Grid container style={{ padding: "25px 15px" }}>
            <Grid container item md={6}>
              <Grid
                container
                item
                md={9}
                direction="column"
                className={classes.myDataBox}
                style={{}}
              >
                <Grid container style={{ gap: 10 }}>
                  <Typography variant="h5" style={{ fontWeight: "bold" }}>
                    نام:
                  </Typography>
                  <Typography variant="h5">{userName}</Typography>
                </Grid>
                <Grid container style={{ gap: 10 }}>
                  <Typography variant="h5" style={{ fontWeight: "bold" }}>
                    سمت:
                  </Typography>
                  <Typography variant="h5">{rolesName?.join(" - ")}</Typography>
                </Grid>
                <Avatar
                  src={Apis.imageUrl + userPhoto}
                  alt="user-photo"
                  style={{
                    position: "absolute",
                    top: -25,
                    right: 40,
                    width: 50,
                    height: 50,
                  }}
                />
                <img
                  src={Path}
                  alt="path"
                  style={{ position: "absolute", top: -10, left: -12 }}
                />
                <img
                  src={Path}
                  alt="path"
                  style={{
                    position: "absolute",
                    bottom: -12,
                    left: -10,
                    transform: "rotate(-90deg)",
                  }}
                />
                <img
                  src={Path}
                  alt="path"
                  style={{
                    position: "absolute",
                    bottom: -12,
                    right: -10,
                    transform: "rotate(180deg)",
                  }}
                />
              </Grid>
            </Grid>
            <Grid container item md={6}>
              <img
                src={myIdeasVector}
                alt={myIdeasVector}
                style={{ maxWidth: "90%" }}
              />
            </Grid>
          </Grid>
          <Grid container style={{ padding: "0 15px", gap: 15 }}>
            <Button
              variant="contained"
              className={
                tab === 1
                  ? classes.containedIdeaBtn10
                  : classes.containedIdeaBtn11
              }
               startIcon={
                <img
                  src={lampChargeRed2}
                  alt="lampChargeRed2"
                  className={classes.lampChargeRed2}
                />
              }
              style={{cursor:'pointer'}}
              onClick={() => setShowAddActivityModal(true)}
            >
            ثبت کنش
            </Button>
            {/* <Button
              variant="contained"
              className={
                tab === 2
                  ? classes.containedIdeaBtn10
                  : classes.containedIdeaBtn11
              }
              startIcon={
                <img
                  src={lampChargeRed2}
                  alt="lampChargeRed2"
                  className={classes.lampChargeRed2}
                />
              }
              // onClick={() => handleActiveTab(2)}
            >
            
            </Button> */}
          </Grid>
          <Grid container direction="column" style={{ padding: "25px 15px" }}>
            <Grid container direction="column" style={{ marginBottom: 40 }}>
              <Grid container wrap="nowrap" style={{ gap: 20 }}>
                <Grid item alignItems="center" className={classes.ideaBoxTitle}>
                  <Typography
                    variant="h4"
                    style={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                  >
                   فعالیت ذخیره شده
                  </Typography>
                </Grid>
                {tab === 1 && (
                  <Grid
                    container
                    flex={1}
                    alignItems="center"
                    className={classes.ideaBoxTitle}
                  >
                    <Grid
                      item
                      className={
                        filterIdea === "all"
                          ? classes.activeIdeaFilter
                          : classes.ideaFilter
                      }
                      // onClick={() => handleIdeaFilters("all")}
                    >
                      همه
                    </Grid>
                    <Grid
                      item
                      className={
                        filterIdea === "registered"
                          ? classes.activeIdeaFilter
                          : classes.ideaFilter
                      }
                      // onClick={() => handleIdeaFilters("registered")}
                    >
                      خانه 
                    </Grid>
                    <Grid
                      item
                      className={
                        filterIdea === "mentored"
                          ? classes.activeIdeaFilter
                          : classes.ideaFilter
                      }
                      // onClick={() => handleIdeaFilters("mentored")}
                    >
                      مدرسه 
                    </Grid>
                    <Grid
                      item
                      className={
                        filterIdea === "accepted"
                          ? classes.activeIdeaFilter
                          : classes.ideaFilter
                      }
                      // onClick={() => handleIdeaFilters("accepted")}
                    >
                      شهری 
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Grid container>
                <InfiniteScrollMyIdea filterIdea={filterIdea} tab={tab} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <AddActivityModalVerses open={showAddActivityModal} role={roles} user={user} close={() => setShowAddActivityModal(false)} />
    </>
  );
}
